import { render, staticRenderFns } from "./BackordersStatus.vue?vue&type=template&id=3a0a2931&scoped=true&"
import script from "./BackordersStatus.vue?vue&type=script&lang=js&"
export * from "./BackordersStatus.vue?vue&type=script&lang=js&"
import style0 from "./BackordersStatus.vue?vue&type=style&index=0&id=3a0a2931&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0a2931",
  null
  
)

export default component.exports